module.exports = __webpack_public_path__ + "img/down-arrow-icon.a68fd491.svg";